<script lang="ts">
  import TextNew from "../TextNew.svelte";
  import Icon from "../icons/Icon.svelte";

  const colorCSSVars = {
    dark: "var(--rk-text-dark)",
    textLow: "var(--rk-text-low)",
  };

  export let name: string;
  export let link: string;
  export let color: "dark" | "textLow" = "dark";
</script>

<a href={link} target="_blank">
  <div class="pos-item">
    <TextNew size="s" --rk-text-color={colorCSSVars[color]}>
      {name}
    </TextNew>
    <Icon name="arrowOpen" --w="24px" --h="24px" />
  </div>
</a>

<style>
  .pos-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 56px;
    border-top: 1px solid var(--rk-divider-0);
    color: var(--rk-neutral-2);
  }

  .pos-item:hover,
  a:focus .pos-item {
    color: var(--rk-text-dark);
  }

  a {
    text-decoration: none;
  }
</style>
